module.exports = __webpack_public_path__ + "static/media/no_connection.27959580.png";